import { render, staticRenderFns } from "./assignRole.vue?vue&type=template&id=204c91c0&scoped=true&"
import script from "./assignRole.vue?vue&type=script&lang=js&"
export * from "./assignRole.vue?vue&type=script&lang=js&"
import style0 from "./assignRole.vue?vue&type=style&index=0&id=204c91c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204c91c0",
  null
  
)

export default component.exports